export default "__VITE_ASSET__$vrkV$C1__"